module.exports = __webpack_public_path__ + "static/media/taps.95b73ce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/taps.jpg
// module id = 621
// module chunks = 0